import React from "react";
// Removed Head import, will use useEffect to manage script
import { useRouter } from "next/router";

/**
 * Interface for the PearWidget component properties.
 */
interface IPearWidget {
  vendorId: string;
  widget: string;
  children?: React.ReactNode;
  config?: Record<string, any>;
}

/**
 * PearWidget component to integrate the Pear Commerce SDK.
 * This component dynamically loads the Pear script based on the provided vendorId and widget type.
 * It also allows for additional configuration options to be passed in.
 *
 * @param {IPearWidget} props - The properties for the PearWidget component.
 * @returns {JSX.Element} The rendered PearWidget component.
 */
const PearWidget = ({
  vendorId,
  widget,
  children,
  config = {}
}: IPearWidget) => {
  const router = useRouter();

  // Create the configuration object
  const pearConfig = {
    vendorId,
    widget,
    ...config
  };

  React.useEffect(() => {
    const scriptId = "pear-commerce-sdk";
    // Remove any existing Pear script
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.parentNode?.removeChild(existingScript);
    }
    // Create new script
    const script = document.createElement("script");
    script.id = scriptId;
    script.type = "text/javascript";
    script.src = `https://offers.pearcommerce.com/js/sdk.js?config=${encodeURIComponent(JSON.stringify(pearConfig))}`;
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(scriptId);
      if (scriptToRemove) {
        scriptToRemove.parentNode?.removeChild(scriptToRemove);
      }
    };
  }, [router.locale]);
  return (
    <>{children}</>
  );
};

export default PearWidget;
